import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListActionsCell } from './emsp-bo-emsp-user-list-actions.cell';
import { EmspBoEmspUserListActionsHeader } from './emsp-bo-emsp-user-list-actions.header';

export const EmspBoEmspUserListActionsColumn: DisplayColumnDef<
  EmspUserModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: EmspBoEmspUserListActionsHeader,
  cell: EmspBoEmspUserListActionsCell,
};
